"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = require("../Typography");

var _Labels = require("../Labels");

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RiskObjectSelector = function RiskObjectSelector(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      label = _ref.label,
      badge = _ref.badge,
      active = _ref.active,
      size = _ref.size,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "onClick", "label", "badge", "active", "size", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledRiskObjectSelector, _extends({
    onClick: onClick,
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement(Button, {
    active: active,
    size: size
  }, children), badge ? /*#__PURE__*/_react.default.createElement(StyledBadge, null, badge) : null, active ? /*#__PURE__*/_react.default.createElement(StyledBadge, null, /*#__PURE__*/_react.default.createElement(_Icons.IconStatusCheck, {
    size: 25,
    color: "white"
  })) : null, label ? /*#__PURE__*/_react.default.createElement(Label, {
    larger: true
  }, label) : null);
};

var StyledRiskObjectSelector = _styledComponents.default.div.withConfig({
  displayName: "StyledRiskObjectSelector"
})(["position:relative;"]);

var Button = _styledComponents.default.div.withConfig({
  displayName: "Button"
})(["background-color:white;border:2px solid ", ";box-shadow:0 0 1px rgba(0,0,0,0.04),0 2px 6px rgba(0,0,0,0.04),0 10px 20px rgba(0,0,0,0.04);border-radius:5px;padding:", ";cursor:pointer;transition:border 0.15s ease-in-out,box-shadow 0.15s ease-in-out;svg path{fill:", ";transition:fill 0.15s ease-in-out;}&:hover{border:2px solid ", ";box-shadow:0 0 1px rgba(0,0,0,0.04),0 2px 6px rgba(0,0,0,0.04),0 16px 24px rgba(0,0,0,0.06);svg path{fill:", ";}}"], function (_ref2) {
  var theme = _ref2.theme,
      active = _ref2.active;
  return active ? theme.brand.primary : '#f0f1f3';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'square' ? '3.5rem' : '2.2rem 7rem';
}, function (_ref4) {
  var theme = _ref4.theme,
      active = _ref4.active;
  return active ? theme.brand.primary : '#c4c4c4';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.brand.primary;
});

var StyledBadge = (0, _styledComponents.default)(_Labels.Badge).withConfig({
  displayName: "StyledBadge"
})(["position:absolute;top:0;right:-1.3rem;padding:1rem;width:auto;transform:translate(0,-50%);"]);
var Label = (0, _styledComponents.default)(_Typography.H4).withConfig({
  displayName: "Label"
})(["width:100%;text-align:center;margin-top:1.6rem;"]);
RiskObjectSelector.propTypes = {
  /** Pass an element to be displayed within the button. */
  children: _propTypes.node.isRequired,

  /** Pass a function to be executed when the button is clicked. */
  onClick: _propTypes.func,

  /** Label to be shown underneath the button. */
  label: _propTypes.string,

  /** text to display within the badge. */
  badge: _propTypes.string,

  /** Set to true to change styling to match an active state. */
  active: _propTypes.bool,

  /** Changes the sizing of the button ("square" / "wide"). */
  size: _propTypes.string,

  /** Extra classes to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
var _default = RiskObjectSelector;
exports.default = _default;